import { timestampDate } from '@bufbuild/protobuf/wkt'
import { compareDesc, isBefore, isWithinInterval } from 'date-fns'
import * as React from 'react'
import { useAuth } from 'react-oidc-context'
import { DeletedItemSelection } from '@/generated/Enumerations/DeletedItemSelection_pb'
import { useUserDetails } from './useUserDetails'

export const useCurrentUserDetails = () => {
    const { user } = useAuth()

    const { data: userDetails } = useUserDetails(
        user?.profile.sub ?? '',
        DeletedItemSelection.NORMAL_ONLY
    )

    return React.useMemo(() => {
        const [mostRecentUserWorkingTimeModel] =
            userDetails.userWorkingTimeModels.toSorted(
                ({ validFrom: a }, { validFrom: b }) =>
                    a && b ?
                        compareDesc(timestampDate(a), timestampDate(b))
                    :   -1
            )
        return {
            ...userDetails,
            currentUserWorkingTimeModel:
                (
                    mostRecentUserWorkingTimeModel?.workingTimeModel &&
                    mostRecentUserWorkingTimeModel.validFrom &&
                    ((mostRecentUserWorkingTimeModel.validUntil &&
                        isWithinInterval(new Date(), {
                            start: timestampDate(
                                mostRecentUserWorkingTimeModel.validFrom
                            ),
                            end: timestampDate(
                                mostRecentUserWorkingTimeModel.validUntil
                            ),
                        })) ||
                        isBefore(
                            timestampDate(
                                mostRecentUserWorkingTimeModel.validFrom
                            ),
                            new Date()
                        ))
                ) ?
                    mostRecentUserWorkingTimeModel
                :   undefined,
        }
    }, [userDetails])
}
